<template>
  <div class="activityList">
    <m-loading :loading="homeLoading" />
    <van-list v-if="swActivity.length>0" v-model="loadingActivity" :finished="finishedActivity" finished-text="没有更多了" @load="onLoadActivity">
      <div v-slidein class="news-item" style="display: block;" v-for="(item, i) in swActivity" :key="i">
        <div class="news-item-content">
          <div class="img-area">
            <img v-setshow :src="item.posterUrl" alt="" />
          </div>
          <div class="news-content">
            <div class="news-tit">{{ item.name }}</div>
            <div class="author2">
              {{ item.startTime +'~' +item.endTime}}
            </div>
          </div>
        </div>
        <div class="overallbaseline news-item-bottom">
          <div v-if="item.typeId == 0" class="overallCenter status ing">进行中</div>
          <div v-if="item.typeId == 1" class="overallCenter status red">已结束</div>
          <div v-if="item.typeId == 2" class="overallCenter status end">未开始</div>
          <div class="overallCenter contributeBtn" v-if="item.typeId == 0 || item.typeId == 2" @click="toActivePage(item)">
            我要报名
          </div>
        </div>
      </div>
    </van-list>
    <div class="nullData" v-else-if="!homeLoading">
      <img class="nullData_img" src="../../assets/images/mine/quesheng.png" alt="">
      <div class="nullData_tip">
        {{type==1?'活动列表为空':'您还没有参与活动'}}
      </div>
    </div>
  </div>
</template>
<script>
import {getPageActivity,getMYPageActivity} from "@/utils/api/home";
export default {
  components: {
  },
  data() {
    return {
      homeLoading:true,
      // 是否加载活动所有数据
      loadingActivity:false,
      finishedActivity:false,
      swActivity:[],
      pageActivity:0,
      type:this.$route.params.type,
    }
  },
  async mounted() {
    let type = this.$route.params.type;
    if(type==1){
      this.onLoadActivity()
    }else if((type==2)){
      this.MYonLoadActivity()
    }
  },
  methods: {
    // 活动列表数据
    onLoadActivity() {
      this.loadingActivity = true;
      this.pageActivity++;
      getPageActivity({
        pageNo: this.pageActivity,
        pageSize: 10
      }).then((res) => {
        if (res.success) {
          let swActivity = res.data.records
          this.swActivity.push(...swActivity);
          if (this.pageActivity * 10 >= res.data.total) this.finishedActivity = true;
          this.loadingActivity = false;
        } else {
          this.loadingActivity = false;
          this.finishedActivity = true;
        }
        this.homeLoading = false
      });
    },
    // 我的活动列表数据
    MYonLoadActivity() {
      this.loadingActivity = true;
      this.pageActivity++;
      getMYPageActivity({
        pageNo: this.pageActivity,
        pageSize: 10
      }).then((res) => {
        if (res.success) {
          let swActivity = res.data.records
          this.swActivity.push(...swActivity);
          if (this.pageActivity * 10 >= res.data.total) this.finishedActivity = true;
          this.loadingActivity = false;
        } else {
          this.loadingActivity = false;
          this.finishedActivity = true;
        }
        this.homeLoading = false
      });
    },
    // 跳转活动页面
    toActivePage(item) {
      window.localStorage.setItem(
        "active_infos_data",
        JSON.stringify(item)
      );
      this.$router.push("/home/apply");
    },
  }
}
</script>
<style lang="scss" scoped>
.activityList{
  position: absolute;
  min-height: 100vh;
  background-color:#F8F8F9;
  width: 375px;
  padding: 0 20px;
  .nullData{
    margin-top: 30%;
    .nullData_img{
      width: 146px;
      height: 120px;
    }
    .nullData_tip{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #404046;
      line-height: 18px;
    }
  }
  .news-item {
    display: flex;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    padding:15px;
    margin-bottom: 15px;
    .news-item-content{
      display: flex;
    }
    .img-area {
      width: 120px;
      min-width: 120px;
      height: 79px;
      border-radius: 10px;
      border: 1px solid #f2f2f2;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .news-content {
      margin-left: 10px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .news-tit {
        max-width: 180px;
        text-align: left;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        color: #222222;
        overflow: hidden;      
        text-overflow: ellipsis;      
        display: -webkit-box; 
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical; 
        -moz-line-clamp: 2;
        -moz-box-orient: vertical;
      }
      .author {
        height: 24px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #999;
        margin-left: 3px;
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .author2{
        // max-width: 160px;
        height: 24px;
        display: flex;
        align-items: center;
        font-size: 10px;
        color: #999;
        margin-left: 3px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transform: scale(0.7);
        transform-origin: left;
      }
    }
    .news-item-bottom{
      margin-top: 11px;
      border-top: 1px solid #F0F0F0;
      padding-top:13px;
    }
    .status {
      font-size: 12px;
      height: 20px;
      text-align: center;
      width: 50px;
      border-radius: 25px 25px 25px 25px;
      color: #FF7246;
      background-color: rgba(255,114,70,0.1);
      &.end {
        background-color: #eee;
      }
      &.red {
        background-color: red;
        color: #ffffff;
      }
    }
    .contributeBtn{
      width: 70px;
      height: 25px;
      background: #31D076;
      border-radius: 25px 25px 25px 25px;
      opacity: 1;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 14px;
    }
  }
  .van-list{
    padding-top: 10px;
  }
}
</style>